import * as receiptEvents from './receipt/receipt-analytics.events'

export const Analytics = {
  receipt: receiptEvents
}
